// extracted by mini-css-extract-plugin
export default {"root":"PreparePage_root__vm-dX","logo":"PreparePage_logo__o72mu","content":"PreparePage_content__zsaWP","continueButton":"PreparePage_continueButton__SDrmZ"};